// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"7196d9ef","884":"7a6381a0","958":"ffa7b281","987":"c2ce9059"}[chunkId] + ".chunk.js";
};